export enum Side {
  BUY = 'BUY', SELL = 'SELL'
}

export namespace Side {

  export function getOppositeSide(side: Side): Side {
    return side === Side.BUY ? Side.SELL : Side.BUY;
  }

  export function fromManualTradeAction(action: string): Side {
    switch (action) {
      case 'BUY':
        return Side.BUY;
      case 'SELL':
        return Side.SELL;
    }
  }
}
